// export const JsonRequest = (r: Response) => r.json();
export const JsonRequest = (r: Response) => {
    if (r.status === 204) return null;
    return r.json();
};
export const TextRequest = (r: Response) => r.text();


const headers = {
    Accept: 'application/json'
};
const schemaHeaders = {
    Accept: 'application/schema+json'
};

const authHeader = () => {
    const access_token = localStorage.getItem('accessToken');
    if (!access_token) { return {} }
    return {
        'Authorization': `Bearer ${access_token}`
    }
}

const authRefreshHeader = () => {
    const access_token = localStorage.getItem('refreshToken');
    if (!access_token) { return {} }
    return {
        'Authorization': `Bearer ${access_token}`
    }
}

export const RequestInitBase: RequestInit = {
    headers: headers,
    credentials: 'same-origin'
};

export const RequestInitGet: RequestInit = RequestInitBase;

export const RequestInitDelete: RequestInit = Object.assign(
    { method: 'DELETE' },
    RequestInitBase
);

export const RequestInitRawPush: any = (method: string, data: any): any => {
    return {
        body: data,
        method: method,
        headers: headers,
        credentials: 'same-origin'
    };
};

export const RequestInitGetSchema: RequestInit = {
    headers: schemaHeaders,
    credentials: 'same-origin'
};

export const RequestInitPush: any = (method: string, data: any): any => {
    return RequestInitRawPush(method, JSON.stringify(data));
};

export const RequestInitPut: any = (data: any) => RequestInitPush('PUT', data);
export const RequestInitPatch: any = (data: any) => RequestInitPush('PATCH', data);

export const RequestInitPost: any = (data: any): any =>
    RequestInitPush('POST', data);

export const ErrorHandler = (response: any) => {
    if (!response.ok || response.status >= 400) {
        const a = response.json().catch(() => {
            return {
                errors: [
                    {
                        status: response.status,
                        message: response.statusText
                    }
                ]
            };
        });
        return a.then((r: any) => {
            console.error(r);
            return Promise.reject(r);
        });
    }
    return response;
};

export const fetchJson = async (url: string, requestInit: RequestInit) => {
    const headers: any = {
        ...requestInit.headers,
        ...authHeader()
    }
    requestInit.headers = headers
    return fetch(url, requestInit).then(ErrorHandler).then(JsonRequest);
}

export const fetchAuthRefreshJson = (url: string, requestInit: RequestInit) => {
    const headers: any = {
        ...requestInit.headers,
        ...authRefreshHeader()
    }
    requestInit.headers = headers
    return fetch(url, requestInit).then(ErrorHandler).then(JsonRequest);
}

export const fetchJsonAndCache = (
    url: string,
    requestInit: RequestInit
): (() => Promise<any>) => {
    let cachedResponse: any;

    return () => {
        if (typeof cachedResponse === 'undefined') {
            return fetchJson(url, requestInit).then((jsonResponse) => {
                cachedResponse = jsonResponse;
                return jsonResponse;
            });
        }

        return Promise.resolve(cachedResponse);
    };
};
